<template>
  <div>
    <h1 class="page-title">{{ $t("NewTimeCode.title_page") }}</h1>
    <div class="row">
      <div class="col-lg-6 form-position-center">
        <div class="card card-transparent">
          <div class="card-block">
            <time-code-form :timeCode="timeCode" @updateStartTime="updateStartTime" @updateEndTime="updateEndTime"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeCodeForm from './TimeCodeForm'
import time_codes_mixin from '@/mixin/timeCodes'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'NewTimeCode',
  mixins: [time_codes_mixin],
  components: { TimeCodeForm },
  computed: {
    ...mapGetters({
      timeCode: 'timeCodes/timeCode'
    }),
  },
  methods: {
    ...mapActions({
      initTimeCode: 'timeCodes/initTimeCode'
    })
  },
  mounted() {
    this.initTimeCode({
      timeCode: {
        start_time: '9:00',
        end_time: '18:00',
        effective_work_minutes: '420',
        entity_id: this.$route.params.entity_id
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/timeCodes/NewTimeCode.vue